const data = [
  {
    id: 'ml_dashboard',
    title : 'Dashboard',
    link: '/admin/dashboard',
    icon: 'flaticon-025-dashboard'
  },
  {
    id: 'ml_user',
    title: 'User',
    icon: 'flaticon-093-waving',
    link: '',
    submenu: [
      {
        title: 'User List',
        link: '/admin/users'
      },
      {
        title: 'Add User',
        link: '/admin/new-user'
      },
      {
        title: 'Edit User',
        link: '/admin/edit-user/:id'
      },
      {
        title: 'Deleted Users',
        link: '/admin/deleted-users'
      },
    ]
  },
  {
    id: 'ml_admin_profile',
    title : 'Admin Profile',
    link: '/admin/admin-profile'
  },
  {
    id: 'ml_general_settings',
    title : 'General Settings',
    link: '/admin/general-settings'
  },
  {
    id: 'ml_cms_pages',
    title : 'CMS Pages',
    link: '/admin/cms-pages'
  },
  {
    id: 'ml_verification_requests',
    title : 'Verification Requests',
    link: '/admin/verification-requests'
  },
  {
    id: 'ml_view_request',
    title : 'View Request',
    link: '/admin/request/:id'
  },
  {
    id: 'ml_themes',
    title : 'Themes',
    link: '/admin/themes'
  },
  {
    id: 'ml_add_theme',
    title : 'Add Theme',
    link: '/admin/add-theme'
  },
  {
    id: 'ml_edit_theme',
    title : 'Edit Theme',
    link: '/admin/edit-theme/:id'
  },
  {
    id: 'ml_faqs',
    title : 'FAQ\'s',
    link: '/admin/faqs'
  },
];
export default data;